import React, { useEffect, useState } from "react";
import { AdminSidebar } from "../Sidebar/Sidebar";
import { AdminTopBar } from "../topbar/Topbar";
import "../Quest/Quests.css";
import "../toggle.css";
import { Link } from "react-router-dom";
import BackButton from "../Goback/GoBack";
import { useGetAllAgreements } from "../../../../hooks/admin/agreement/useGetAllAgreement";
import Skeleton from "react-loading-skeleton";

export const AdminAllAgreements = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  const { agreements, meta, stats, loading, fetchAgreements } =
    useGetAllAgreements();

  // Sidebar toggle
  const toggleSidebar = () => setIsSidebarCollapsed(!isSidebarCollapsed);

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
      setPage(1);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  // Fetch agreements on page / filter change
  useEffect(() => {
    const filters = {};

    if (debouncedSearchQuery) {
      filters.institution_name = debouncedSearchQuery;
    }

    if (statusFilter !== "all") {
      filters.status = statusFilter;
    }

    fetchAgreements({ page, filters });
  }, [page, debouncedSearchQuery, statusFilter]);

  return (
    <div className="dashboardBody">
      <AdminSidebar isSidebarCollapsed={isSidebarCollapsed} />

      <div className="container-fluid p-0">
        <div id="mainContent">
          <AdminTopBar toggleSidebar={toggleSidebar} />

          <div className="teacher-bodycontent mb-4">
            <section>
              <div className="container-fluid">
                <div className="row mb-4 align-items-center">
                  <div className="col-12">
                    <BackButton />
                  </div>

                  <div className="col-md-4 my-2">
                    <p className="tchrdashboard-cmntitl mb-0">All Agreements</p>
                  </div>

                  <div className="col-md-4 my-2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by institution name..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>

                  <div className="col-md-4 text-md-end my-2">
                    <Link
                      to="/school/agreement/create"
                      className="add-school-btn"
                    >
                      Create Agreement
                    </Link>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-2">
                    <select
                      className="form-select"
                      value={statusFilter}
                      onChange={(e) => {
                        setStatusFilter(e.target.value);
                        setPage(1);
                      }}
                    >
                      <option value="all">All</option>
                      <option value="active">Active</option>
                      <option value="pending">Pending</option>
                    </select>
                  </div>
                </div>

                <div className="d-block">
                  <div className="table-responsive">
                    <table className="table table-hover tchrtabl-pdng">
                      <thead className="quest-tablehead">
                        <tr>
                          <th>Sr. No</th>
                          <th>School Name</th>
                          <th>Licenses</th>
                          <th>Total Duration</th>
                          <th>Mode</th>
                          <th>Price</th>
                          <th>Status</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>

                      <tbody className="tchrtablbody">
                        {loading && (
                          <tr>
                            <td colSpan="8" className="text-center">
                              <Skeleton
                                count={5}
                                height={40}
                                className="mb-3"
                              />
                            </td>
                          </tr>
                        )}

                        {!loading && agreements.length === 0 && (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No agreements found
                            </td>
                          </tr>
                        )}

                        {!loading &&
                          agreements.map((item, index) => (
                            <tr key={item.id}>
                              <td>
                                {(meta?.current_page - 1) *
                                  (meta?.per_page || 15) +
                                  index +
                                  1}
                              </td>
                              <td>{item?.institution?.name}</td>
                              <td>{item?.base_licenses}</td>
                              <td>
                                {item?.duration_value}{" "}
                                {item?.duration_unit.toLocaleUpperCase()}
                              </td>
                              <td>{item?.billing_mode}</td>
                              <td>
                                {item?.currency === "INR" ? "₹" : "$"}
                                {Number(item?.price_per_unit).toLocaleString(
                                  "en-IN",
                                )}{" "}
                                <sub>
                                  {item?.duration_unit === "year"
                                    ? "/Yr"
                                    : `/${item?.duration_value}Mo`}
                                </sub>
                              </td>
                              <td>
                                <span
                                  className={`badge rounded-pill px-3 py-2 ${
                                    item?.status === "active"
                                      ? "bg-success"
                                      : item.status === "pending"
                                        ? "bg-warning text-dark"
                                        : "bg-secondary"
                                  }`}
                                >
                                  {item.status.toLocaleUpperCase()}
                                </span>
                              </td>

                              <td className="text-center">
                                <Link to={`/school/agreement/edit/${item.id}`}>
                                  <i
                                    className="fa fa-eye text-black"
                                    aria-hidden="true"
                                  ></i>
                                </Link>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Pagination */}
                {meta && meta.last_page > 1 && !loading && (
                  <div className="pagination">
                    <button
                      onClick={() => setPage((p) => Math.max(p - 1, 1))}
                      disabled={page === 1}
                    >
                      Previous
                    </button>

                    <button className="active">{page}</button>

                    <button
                      onClick={() =>
                        setPage((p) => Math.min(p + 1, meta.last_page))
                      }
                      disabled={page === meta.last_page}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};
